export default __webpack_public_path__ + "static/media/add.ba0cb2a9.png";